import { NgModule } from '@angular/core';
import {
  MatButtonModule,
  MatDialogModule,
  MatIconModule,
  MatProgressSpinnerModule,
} from '@angular/material';
import { SharedModule } from 'ngx-mat-esign360/lib/shared/shared.module';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { DialogConfirmButtonsComponent } from './components/dialog-confirm-buttons/dialog-confirm-buttons.component';
import { SpinnerDialogComponent } from './components/spinner-dialog/spinner-dialog.component';
import { ForkDialogComponent } from './components/fork-dialog/fork-dialog.component';
import { DialogLayoutComponent } from './components/dialog-layout/dialog-layout.component';
import { SimpleDialogContentComponent } from './components/simple-dialog-content/simple-dialog-content.component';
import { ThemedImageModule } from '../themed-image/themed-image.module';

@NgModule({
  declarations: [
    ConfirmDialogComponent,
    AlertDialogComponent,
    DialogConfirmButtonsComponent,
    SpinnerDialogComponent,
    ForkDialogComponent,
    DialogLayoutComponent,
    SimpleDialogContentComponent,
  ],
  imports: [
    SharedModule,
    ThemedImageModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    ConfirmDialogComponent,
    DialogConfirmButtonsComponent,
    ForkDialogComponent,
    DialogLayoutComponent,
    SimpleDialogContentComponent,
  ],
})
export class DialogModule {}
